import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "select2/dist/css/select2.min.css";
import "select2";
import "./App.css";
import Roots from "./Components/Roots";

function App() {
  const router = createBrowserRouter([{ path: "*", element: <Roots /> }]);

  return <RouterProvider router={router} />;
}

export default App;
